import PlaneCard from '../Common/PlaneCard';
import { useLang } from '@/i18n';
export default function SectionMicroinverter() {
    const { t } = useLang('theProduct.SectionMicroinverter');

    return (
        <PlaneCard
            title={t('title')}
            desc={t('desc')}
            isVideo={true}
            pc="https://websiteoss.ecoflow.com/upload/video/1744602386591/mobile.mp4"
            h5="https://websiteoss.ecoflow.com/upload/video/1744602386591/mobile.mp4"
        />
    );
}
